import { render, staticRenderFns } from "./TelInputAuth.vue?vue&type=template&id=288d5572&scoped=true"
import script from "./TelInputAuth.vue?vue&type=script&lang=js"
export * from "./TelInputAuth.vue?vue&type=script&lang=js"
import style0 from "./TelInputAuth.vue?vue&type=style&index=0&id=288d5572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d5572",
  null
  
)

export default component.exports